/* ================= RUGZI theme.js ================= */
(function () {
  "use strict";
  var R = window.RUGZI || {};

  /* ---------- helpers ---------- */
  function money(cents) {
    return "$" + (cents / 100).toFixed(2).replace(/\.00$/, "");
  }
  var toastTimer;
  function toast(msg) {
    var t = document.getElementById("toast");
    if (!t) return;
    t.textContent = msg;
    t.classList.add("show");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove("show"); }, 2400);
  }
  window.rugziToast = toast;

  /* ---------- nav blur + mobile menu ---------- */
  var nav = document.querySelector(".nav");
  window.addEventListener("scroll", function () {
    if (nav) nav.classList.toggle("scrolled", window.scrollY > 20);
    var hb = document.querySelector(".hero-media");
    if (hb) hb.style.transform = "translateY(" + window.scrollY * 0.18 + "px)";
  });
  window.rugziMenu = function (open) {
    var m = document.getElementById("mmenu");
    if (m) m.classList.toggle("show", open);
  };

  /* ---------- reveal on scroll ---------- */
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); }
    });
  }, { threshold: 0.12 });
  document.querySelectorAll(".reveal").forEach(function (el) { io.observe(el); });

  /* ---------- accordions ---------- */
  window.rugziAcc = function (btn) {
    var qa = btn.parentElement, ans = qa.querySelector(".ans");
    var open = qa.classList.contains("open");
    var group = qa.closest(".acc, .faq");
    if (group) group.querySelectorAll(".qa").forEach(function (q) {
      q.classList.remove("open"); q.querySelector(".ans").style.maxHeight = null;
    });
    if (!open) { qa.classList.add("open"); ans.style.maxHeight = ans.scrollHeight + "px"; }
  };
  document.querySelectorAll(".qa.open .ans").forEach(function (a) { a.style.maxHeight = a.scrollHeight + "px"; });

  /* ---------- wishlist toggle ---------- */
  document.addEventListener("click", function (e) {
    var w = e.target.closest(".wish, .g-wish");
    if (w) {
      e.preventDefault();
      w.classList.toggle("on");
      toast(w.classList.contains("on") ? "Saved to wishlist" : "Removed from wishlist");
    }
  });

  /* ================= CART ================= */
  var overlay = document.getElementById("overlay");
  var drawer = document.getElementById("cartDrawer");

  function openCart() { if (drawer) drawer.classList.add("show"); if (overlay) overlay.classList.add("show"); }
  function closeCart() { if (drawer) drawer.classList.remove("show"); if (overlay) overlay.classList.remove("show"); }
  window.rugziOpenCart = openCart;
  window.rugziCloseCart = closeCart;

  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-open-cart]")) { e.preventDefault(); refreshCart(); openCart(); }
    if (e.target.closest("[data-close-cart]")) { e.preventDefault(); closeCart(); }
  });

  // Persistent free-shipping progress bar under the header
  function updateHeaderShip(cart) {
    var bar = document.getElementById("headerShipBar");
    if (!bar) return;
    var goal = R.freeShip || 0;
    if (goal <= 0 || !cart || cart.item_count === 0) { bar.hidden = true; return; }
    bar.hidden = false;
    var msg = document.getElementById("headerShipMsg");
    var fill = document.getElementById("headerShipFill");
    var pct = Math.min(100, Math.round((cart.total_price / goal) * 100));
    if (cart.total_price >= goal) {
      msg.innerHTML = "<b>Free shipping unlocked!</b>";
      bar.classList.add("done");
    } else {
      msg.innerHTML = "You're <b>" + money(goal - cart.total_price) + "</b> away from free shipping";
      bar.classList.remove("done");
    }
    if (fill) fill.style.width = pct + "%";
  }

  function renderCart(cart) {
    var body = document.getElementById("cartBody");
    var foot = document.getElementById("cartFoot");
    var countEls = document.querySelectorAll(".cart-count");
    countEls.forEach(function (c) {
      c.textContent = cart.item_count;
      c.classList.toggle("has-items", cart.item_count > 0);
    });
    updateHeaderShip(cart);
    if (!body) return;
    if (!cart.items.length) {
      body.innerHTML = '<div class="cart-empty">Your cart is empty.<br>Time to find your statement piece.</div>';
      if (foot) foot.style.display = "none";
      return;
    }
    body.innerHTML = cart.items.map(function (it) {
      var img = it.image
        ? '<img src="' + it.image.replace(/(\.[a-z]+)(\?|$)/, "_120x120$1$2") + '" alt="">'
        : '<div class="ph"></div>';
      return '<div class="ci" data-key="' + it.key + '">' + img +
        '<div class="info"><h4>' + it.product_title + '</h4>' +
        (it.variant_title && it.variant_title !== "Default Title" ? '<div style="font-size:12px;color:var(--text2)">' + it.variant_title + '</div>' : '') +
        '<div class="cqty"><button data-cq="-1" data-key="' + it.key + '">−</button>' + it.quantity + '<button data-cq="1" data-key="' + it.key + '">+</button></div>' +
        '<div class="rm" data-rm="' + it.key + '">Remove</div></div>' +
        '<div class="price">' + money(it.final_line_price) + '</div></div>';
    }).join("");
    if (foot) {
      foot.style.display = "block";
      document.getElementById("cartTotal").textContent = money(cart.total_price);
      var goal = R.freeShip || 0;
      var bar = document.getElementById("shipBar"), msg = document.getElementById("shipMsg");
      if (bar && msg) {
        if (goal <= 0) { msg.textContent = "🚚 Free worldwide shipping included"; bar.style.width = "100%"; }
        else if (cart.total_price >= goal) { msg.textContent = "🎉 You unlocked free express shipping!"; msg.style.color = "var(--success)"; bar.style.width = "100%"; }
        else { msg.textContent = "Add " + money(goal - cart.total_price) + " more for free express shipping"; msg.style.color = "#333"; bar.style.width = (cart.total_price / goal * 100) + "%"; }
      }
    }
  }

  function refreshCart() {
    fetch(R.routes.cart + ".js").then(function (r) { return r.json(); }).then(renderCart);
  }

  function changeCart(key, qty) {
    var body = document.getElementById("cartBody");
    if (body) body.classList.add("updating");
    fetch(R.routes.cart_change + ".js", {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); })
      .catch(function () { toast("Could not update cart"); })
      .then(function () { if (body) body.classList.remove("updating"); });
  }

  document.addEventListener("click", function (e) {
    var cq = e.target.closest("[data-cq]");
    if (cq) {
      var key = cq.getAttribute("data-key");
      var row = cq.closest(".ci");
      var current = parseInt(row.querySelector(".cqty").childNodes[1].textContent, 10);
      changeCart(key, current + parseInt(cq.getAttribute("data-cq"), 10));
    }
    var rm = e.target.closest("[data-rm]");
    if (rm) changeCart(rm.getAttribute("data-rm"), 0);
  });

  /* ---------- add to cart (works for any [data-add-to-cart] form) ---------- */
  // Applies a Shopify discount code to the session (used by bundle tiers)
  function applyDiscount(code) {
    if (!code) return Promise.resolve();
    return fetch("/discount/" + encodeURIComponent(code), { method: "GET", credentials: "same-origin" })
      .catch(function () { /* non-fatal: cart still works without it */ });
  }
  window.rugziApplyDiscount = applyDiscount;

  // Visual loading state so taps feel instant and can't be double-fired
  function setLoading(btn, on) {
    if (!btn) return;
    if (on) { btn.classList.add("is-loading"); btn.disabled = true; }
    else { btn.classList.remove("is-loading"); btn.disabled = false; }
  }

  function addIds(items, cb, btn) {
    // drop anything without a usable variant id
    items = (items || []).filter(function (i) { return i && i.id; });
    if (!items.length) { toast("This item is unavailable"); setLoading(btn, false); return; }
    setLoading(btn, true);
    fetch(R.routes.cart_add + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (data) { return { ok: r.ok, data: data }; });
    }).then(function (res) {
      setLoading(btn, false);
      if (!res.ok) {
        // surface Shopify's real reason instead of failing silently
        toast(res.data && res.data.description ? res.data.description : "Could not add to cart");
        return;
      }
      refreshCart(); openCart(); if (cb) cb();
    }).catch(function () { setLoading(btn, false); toast("Could not add to cart"); });
  }
  window.rugziAddIds = addIds;

  // Intercept ONLY the Add-to-Cart button so the native dynamic checkout
  // (Shop Pay / Buy it now) button in the same form still goes straight to checkout.
  document.addEventListener("click", function (e) {
    var b = e.target.closest(".js-atc");
    if (!b) return;
    e.preventDefault();
    var form = b.closest("form");
    if (!form) return;
    var id = form.querySelector('[name="id"]').value;
    var qtyEl = form.querySelector('[name="quantity"]');
    var qty = qtyEl ? parseInt(qtyEl.value, 10) : 1;
    // if a bundle tier with a discount code is selected, apply it first
    var bundle = window.RUGZI_bundle;
    var code = bundle && bundle.code ? bundle.code : "";
    setLoading(b, true);
    applyDiscount(code).then(function () {
      addIds([{ id: id, quantity: qty }], function () {
        toast(bundle && bundle.discount > 0 ? "Bundle added — " + bundle.discount + "% off applied" : "Added to cart");
      }, b);
    });
  });

  /* quick add buttons (variant id in data-variant) */
  document.addEventListener("click", function (e) {
    var b = e.target.closest("[data-quick-add]");
    if (!b) return;
    e.preventDefault();
    addIds([{ id: b.getAttribute("data-variant"), quantity: 1 }], function () { toast("Added to cart"); }, b);
  });

  refreshCart();

  /* ================= PRODUCT PAGE ================= */
  var pdp = document.querySelector(".pdp");
  if (pdp) initProduct(pdp);

  function initProduct(root) {
    var data = document.getElementById("ProductJSON");
    var product = data ? JSON.parse(data.textContent) : null;

    /* gallery */
    var mainImg = root.querySelector(".main-img");
    var mainImgTag = mainImg ? mainImg.querySelector("img") : null;
    root.querySelectorAll(".thumb").forEach(function (t) {
      t.addEventListener("click", function () {
        root.querySelectorAll(".thumb").forEach(function (x) { x.classList.remove("active"); });
        t.classList.add("active");
        if (mainImgTag) mainImgTag.src = t.getAttribute("data-full");
      });
    });
    if (mainImg && mainImgTag) {
      mainImg.addEventListener("mousemove", function (e) {
        var r = mainImg.getBoundingClientRect();
        mainImgTag.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + "% " + ((e.clientY - r.top) / r.height * 100) + "%";
      });
      mainImg.addEventListener("mouseenter", function () { mainImg.classList.add("zoom"); });
      mainImg.addEventListener("mouseleave", function () { mainImg.classList.remove("zoom"); });
    }

    /* variant selection */
    var optionEls = root.querySelectorAll("[data-option-index]");
    function currentOptions() {
      var opts = [];
      root.querySelectorAll(".opt[data-option-index]").forEach(function (group) {
        var sel = group.querySelector(".chip.on, .sw.on");
        opts[parseInt(group.getAttribute("data-option-index"), 10)] = sel ? sel.getAttribute("data-value") : null;
      });
      return opts;
    }
    function findVariant(opts) {
      if (!product) return null;
      return product.variants.find(function (v) {
        return opts.every(function (o, i) { return v.options[i] === o; });
      });
    }
    function updateVariant() {
      if (!product) return;
      var v = findVariant(currentOptions());
      if (!v) return;
      var idInput = root.querySelector('[name="id"]');
      if (idInput) idInput.value = v.id;
      // swap the gallery image when the selected variant has its own photo
      if (v.featured_image && v.featured_image.src && mainImgTag) {
        var newSrc = v.featured_image.src;
        mainImgTag.src = newSrc;
        root.querySelectorAll(".thumb").forEach(function (t) {
          var full = t.getAttribute("data-full") || "";
          var base = full.split("?")[0].replace(/_\d+x\d*(\.[a-z]+)$/i, "$1");
          t.classList.toggle("active", newSrc.indexOf(base.split("/").pop().split(".")[0]) > -1);
        });
      }
      var priceEl = root.querySelector(".price");
      var cmpEl = root.querySelector(".price-compare");
      var saveEl = root.querySelector(".save");
      if (priceEl) priceEl.textContent = money(v.price);
      // Add-to-cart shows the real total the shopper will pay (bundle aware)
      var atc = root.querySelector(".js-atc-price");
      if (atc) {
        var b = window.RUGZI_bundle;
        if (b && b.qty > 1) {
          var total = Math.round(v.price * b.qty * (1 - (b.discount || 0) / 100));
          atc.textContent = money(total);
        } else {
          atc.textContent = money(v.price);
        }
      }
      var sticky = document.querySelector(".js-sticky-price");
      if (sticky) sticky.textContent = money(v.price);
      if (v.compare_at_price && v.compare_at_price > v.price) {
        if (cmpEl) { cmpEl.textContent = money(v.compare_at_price); cmpEl.style.display = ""; }
        if (saveEl) {
          var diff = v.compare_at_price - v.price;
          var pct = Math.round(diff / v.compare_at_price * 100);
          saveEl.textContent = "You save " + money(diff) + " (" + pct + "%)";
          saveEl.style.display = "";
        }
      } else {
        if (cmpEl) cmpEl.style.display = "none";
        if (saveEl) saveEl.style.display = "none";
      }
      // Store always continues selling — never disable the button on a stale availability flag.
      var btn = root.querySelector(".js-atc");
      if (btn) { btn.disabled = false; btn.classList.remove("sold"); }
    }
    // Only bind real variant options (scoped so bundle tiers never interfere)
    root.querySelectorAll(".opt[data-option-index] .chip, .opt[data-option-index] .sw").forEach(function (chip) {
      if (chip.classList.contains("sold")) return;
      chip.addEventListener("click", function () {
        var group = chip.closest(".opt");
        group.querySelectorAll(".chip, .sw").forEach(function (x) { x.classList.remove("on"); });
        chip.classList.add("on");
        var selLabel = group.querySelector(".sel");
        if (selLabel) selLabel.textContent = chip.getAttribute("data-value");
        updateVariant();
      });
    });

    /* quantity */
    var qtyInput = root.querySelector('[name="quantity"]');
    var qtyVal = root.querySelector(".js-qty-val");
    function setQty(n) {
      n = Math.max(1, n);
      if (qtyInput) qtyInput.value = n;
      if (qtyVal) qtyVal.textContent = n;
    }
    window.rugziQty = function (d) {
      if (!qtyInput) return;
      setQty(parseInt(qtyInput.value, 10) + d);
      // manual quantity change means the shopper is off the bundle tiers
      clearBundle();
      updateVariant();
    };

    /* ---------- BUNDLE & SAVE (functional) ---------- */
    var bundleWrap = root.querySelector("[data-bundle]");
    var bundleNote = root.querySelector("[data-bundle-note]");

    function clearBundle() {
      if (!bundleWrap) return;
      bundleWrap.querySelectorAll(".bundle-tier").forEach(function (t) { t.classList.remove("on"); });
      window.RUGZI_bundle = null;
      if (bundleNote) bundleNote.textContent = "";
    }

    if (bundleWrap) {
      var tiers = bundleWrap.querySelectorAll(".bundle-tier");
      tiers.forEach(function (tier) {
        tier.addEventListener("click", function () {
          tiers.forEach(function (t) { t.classList.remove("on"); });
          tier.classList.add("on");

          var q = parseInt(tier.getAttribute("data-bundle-qty"), 10) || 1;
          var disc = parseFloat(tier.getAttribute("data-bundle-discount")) || 0;
          var code = tier.getAttribute("data-bundle-code") || "";

          setQty(q);
          window.RUGZI_bundle = { qty: q, discount: disc, code: code };
          updateVariant();

          if (bundleNote) {
            if (disc > 0) {
              var v = findVariant(currentOptions()) || (product && product.variants[0]);
              var saved = v ? Math.round(v.price * q * disc / 100) : 0;
              bundleNote.textContent = "You save " + money(saved) + " with this bundle — discount applies at checkout.";
              bundleNote.classList.add("on");
            } else {
              bundleNote.textContent = "";
              bundleNote.classList.remove("on");
            }
          }
        });
      });
      // pick up the pre-selected first tier
      var pre = bundleWrap.querySelector(".bundle-tier.on");
      if (pre) {
        window.RUGZI_bundle = {
          qty: parseInt(pre.getAttribute("data-bundle-qty"), 10) || 1,
          discount: parseFloat(pre.getAttribute("data-bundle-discount")) || 0,
          code: pre.getAttribute("data-bundle-code") || ""
        };
        setQty(window.RUGZI_bundle.qty);
      }
    }

    updateVariant();

    /* sticky ATC */
    var stick = document.querySelector(".sticky-atc");
    var anchor = root.querySelector(".buy-actions");
    if (stick && anchor) {
      new IntersectionObserver(function (e) {
        stick.classList.toggle("show", !e[0].isIntersecting && e[0].boundingClientRect.top < 0);
      }, { threshold: 0 }).observe(anchor);
    }

    /* countdown */
    var cd = root.querySelector(".countdown");
    if (cd) {
      var end = Date.now() + (4 * 3600 + 37 * 60) * 1000;
      setInterval(function () {
        var d = Math.max(0, end - Date.now());
        var h = Math.floor(d / 3.6e6), m = Math.floor(d % 3.6e6 / 6e4), s = Math.floor(d % 6e4 / 1e3);
        var H = root.querySelector(".cd-h"), M = root.querySelector(".cd-m"), S = root.querySelector(".cd-s");
        if (H) H.textContent = String(h).padStart(2, "0");
        if (M) M.textContent = String(m).padStart(2, "0");
        if (S) S.textContent = String(s).padStart(2, "0");
      }, 1000);
    }
    var viewers = root.querySelector(".js-viewers");
    if (viewers) setInterval(function () { viewers.textContent = 30 + Math.floor(Math.random() * 14); }, 3200);

    /* frequently bought together */
    var fbt = document.querySelector(".fbt");
    if (fbt) {
      var base = parseInt(fbt.getAttribute("data-base") || "0", 10);
      function fbtCalc() {
        var t = base;
        fbt.querySelectorAll(".fbtChk:checked").forEach(function (c) { t += parseInt(c.getAttribute("data-price"), 10); });
        var el = document.getElementById("fbtTotal");
        if (el) el.textContent = money(t);
      }
      fbt.querySelectorAll(".fbtChk").forEach(function (c) { c.addEventListener("change", fbtCalc); });
      var addAll = fbt.querySelector(".js-fbt-add");
      if (addAll) addAll.addEventListener("click", function () {
        var items = [{ id: fbt.getAttribute("data-base-variant"), quantity: 1 }];
        fbt.querySelectorAll(".fbtChk:checked").forEach(function (c) {
          if (c.getAttribute("data-variant")) items.push({ id: c.getAttribute("data-variant"), quantity: 1 });
        });
        addIds(items, function () { toast("Bundle added 🎉"); });
      });
      fbtCalc();
    }
  }

  /* ---------- estimated delivery date range ---------- */
  document.querySelectorAll(".js-eta").forEach(function (el) {
    var opt = { month: "short", day: "numeric" };
    var d1 = new Date(Date.now() + 4 * 864e5);
    var d2 = new Date(Date.now() + 8 * 864e5);
    el.textContent = d1.toLocaleDateString(undefined, opt) + " – " + d2.toLocaleDateString(undefined, opt);
  });

  /* ---------- before / after slider ---------- */
  document.querySelectorAll("[data-before-after]").forEach(function (ba) {
    var after = ba.querySelector(".ba-after");
    var handle = ba.querySelector(".ba-handle");
    var drag = false;
    function set(x) {
      var r = ba.getBoundingClientRect();
      var p = Math.max(2, Math.min(98, (x - r.left) / r.width * 100));
      after.style.clipPath = "inset(0 " + (100 - p) + "% 0 0)";
      handle.style.left = p + "%";
    }
    ba.addEventListener("mousedown", function (e) { drag = true; set(e.clientX); });
    window.addEventListener("mousemove", function (e) { if (drag) set(e.clientX); });
    window.addEventListener("mouseup", function () { drag = false; });
    ba.addEventListener("touchstart", function (e) { set(e.touches[0].clientX); }, { passive: true });
    ba.addEventListener("touchmove", function (e) { set(e.touches[0].clientX); }, { passive: true });
  });

  /* ---------- product image lightbox (fullscreen + swipe) ---------- */
  (function initLightbox() {
    var main = document.querySelector(".main-img");
    var lb = document.getElementById("lightbox");
    if (!main || !lb) return;
    var lbImg = document.getElementById("lbImg");
    var lbIndex = document.getElementById("lbIndex");
    var lbTotal = document.getElementById("lbTotal");
    var thumbs = Array.prototype.slice.call(document.querySelectorAll(".thumbs .thumb"));
    function list() {
      if (thumbs.length) return thumbs.map(function (t) { return t.getAttribute("data-full"); });
      var m = main.querySelector("img");
      return m ? [m.getAttribute("data-full") || m.src] : [];
    }
    var imgs = list();
    if (!imgs.length) return;
    var idx = 0;
    lbTotal.textContent = imgs.length;
    function show(i) { idx = (i + imgs.length) % imgs.length; lbImg.src = imgs[idx]; lbIndex.textContent = idx + 1; }
    function open(i) { imgs = list(); lbTotal.textContent = imgs.length; show(i); lb.classList.add("show"); lb.setAttribute("aria-hidden", "false"); document.body.style.overflow = "hidden"; }
    function close() { lb.classList.remove("show"); lb.setAttribute("aria-hidden", "true"); document.body.style.overflow = ""; }
    main.addEventListener("click", function (e) {
      if (e.target.closest(".g-wish, .g-badge, button")) return;
      var active = document.querySelector(".thumb.active");
      var start = active ? thumbs.indexOf(active) : 0;
      open(start < 0 ? 0 : start);
    });
    lb.querySelector(".lb-close").addEventListener("click", close);
    lb.querySelector(".lb-prev").addEventListener("click", function (e) { e.stopPropagation(); show(idx - 1); });
    lb.querySelector(".lb-next").addEventListener("click", function (e) { e.stopPropagation(); show(idx + 1); });
    lb.addEventListener("click", function (e) { if (e.target === lb || e.target.classList.contains("lb-stage")) close(); });
    document.addEventListener("keydown", function (e) {
      if (!lb.classList.contains("show")) return;
      if (e.key === "Escape") close();
      else if (e.key === "ArrowLeft") show(idx - 1);
      else if (e.key === "ArrowRight") show(idx + 1);
    });
    var sx = 0, sy = 0;
    lb.addEventListener("touchstart", function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
    lb.addEventListener("touchend", function (e) {
      var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) show(dx < 0 ? idx + 1 : idx - 1);
    }, { passive: true });
  })();

  /* ---------- newsletter demo submit ---------- */
  document.addEventListener("submit", function (e) {
    var f = e.target.closest(".js-news");
    if (f && f.getAttribute("data-demo") === "true") { e.preventDefault(); toast("You're in! Check your inbox for your code."); f.reset(); }
  });

  /* ---------- password page: countdown + owner panel ---------- */
  (function () {
    var toggle = document.querySelector("[data-pw-toggle]");
    var panel = document.getElementById("pwOwnerPanel");
    if (toggle && panel) {
      toggle.addEventListener("click", function () {
        var open = !panel.hidden;
        panel.hidden = open;
        toggle.classList.toggle("open", !open);
        if (!open) {
          var i = panel.querySelector('input[type="password"]');
          if (i) setTimeout(function () { i.focus(); }, 50);
        }
      });
      // if the password was wrong, Shopify re-renders with an error — keep it open
      if (panel.querySelector(".pw-err")) { panel.hidden = false; toggle.classList.add("open"); }
    }

    var cd = document.querySelector(".pw-countdown[data-launch]");
    if (!cd) return;
    var raw = (cd.getAttribute("data-launch") || "").trim().replace(" ", "T");
    var target = new Date(raw).getTime();
    if (isNaN(target)) { cd.style.display = "none"; return; }
    var d = cd.querySelector("[data-cd-d]"), h = cd.querySelector("[data-cd-h]"),
        m = cd.querySelector("[data-cd-m]"), s = cd.querySelector("[data-cd-s]");
    function pad(n) { return String(n).padStart(2, "0"); }
    function tick() {
      var diff = target - Date.now();
      if (diff <= 0) { cd.classList.add("done"); diff = 0; }
      d.textContent = pad(Math.floor(diff / 864e5));
      h.textContent = pad(Math.floor(diff % 864e5 / 36e5));
      m.textContent = pad(Math.floor(diff % 36e5 / 6e4));
      s.textContent = pad(Math.floor(diff % 6e4 / 1e3));
    }
    tick();
    setInterval(tick, 1000);
  })();

  /* ---------- custom work gallery: flip design <-> finished rug ---------- */
  (function () {
    var cards = document.querySelectorAll(".cg-card[data-flip]");
    if (!cards.length) return;
    cards.forEach(function (card) {
      var btn = card.querySelector(".cg-flip");
      var txt = card.querySelector(".cg-flip-txt");
      function flip() {
        var now = card.classList.toggle("flipped");
        if (txt) txt.textContent = now ? "See the rug" : "See their design";
        if (btn) btn.setAttribute("aria-label", now ? "Show the finished rug" : "Show the original design");
      }
      if (btn) btn.addEventListener("click", function (e) { e.preventDefault(); e.stopPropagation(); flip(); });
      // tapping anywhere on the image also flips (nice on mobile)
      var media = card.querySelector(".cg-media");
      if (media) media.addEventListener("click", function (e) {
        if (e.target.closest(".cg-flip")) return;
        flip();
      });
    });
  })();

  /* ---------- custom rug ORDER page ---------- */
  (function () {
    var form = document.getElementById("CustomRugForm");
    if (!form) return;

    var frame = document.getElementById("crpFrame");
    var artWrap = document.getElementById("crpArtWrap");
    var img = document.getElementById("crpPreview");
    var empty = document.getElementById("crpEmpty");
    var adjust = document.getElementById("crpAdjust");
    var zoomEl = document.getElementById("crpZoom");
    var zoomVal = document.getElementById("crpZoomVal");
    var resetBtn = document.getElementById("crpReset");
    var fileInput = document.getElementById("crpFile");
    var composed = document.getElementById("crpComposed");
    var drop = document.getElementById("crpDrop");
    var dropMain = document.getElementById("crpDropMain");
    var variantInput = document.getElementById("crpVariantId");
    var priceEl = document.getElementById("crpPrice");
    var qtyInput = document.getElementById("crpQty");
    var qtyVal = document.getElementById("crpQtyVal");
    var submit = document.getElementById("crpSubmit");
    var errEl = document.getElementById("crpErr");
    var note = document.getElementById("crpShapeNote");
    var shapeField = document.getElementById("crpShapeField");

    var shapeCopy = {
      round: "Round — your design fills the circle.",
      square: "Square — your design fills the whole rug.",
      rect: "Rectangle — your design fills the whole rug."
    };
    var shapeName = { round: "Round", square: "Square", rect: "Rectangle" };

    // transform state for the uploaded artwork
    var st = { scale: 1, base: 1, x: 0, y: 0, natW: 0, natH: 0, isImage: false };
    var aspect = 1;

    /* ---- the preview matches the REAL dimensions of the chosen size ---- */
    var orient = "landscape";
    var lastSizeTitle = "";
    var orientField = document.getElementById("crpOrientField");
    var hasOrient = !!document.querySelector(".crp-or");

    function applyAspectFrom(title) {
      if (title) lastSizeTitle = title;
      var m = (lastSizeTitle || "").match(/(\d+(?:[.,]\d+)?)\s*[x×*]\s*(\d+(?:[.,]\d+)?)/i);
      var a = 1; // round sizes ("Ø 80 cm") have no W x H -> circle
      if (m) {
        var w = parseFloat(m[1].replace(",", "."));
        var h = parseFloat(m[2].replace(",", "."));
        if (w > 0 && h > 0) {
          a = w / h;
          if (hasOrient) {
            var longSide = Math.max(w, h), shortSide = Math.min(w, h);
            a = orient === "portrait" ? shortSide / longSide : longSide / shortSide;
          }
        }
      }
      aspect = a;
      frame.style.aspectRatio = aspect + " / 1";
      frame.style.setProperty("--ar", aspect);
      requestAnimationFrame(function () { fitCover(); });
    }

    /* ---- sizing maths ---- */
    function fitCover() {
      if (!st.natW || !st.natH) return;
      var fw = frame.clientWidth, fh = frame.clientHeight;
      if (!fw || !fh) return;
      st.base = Math.max(fw / st.natW, fh / st.natH); // cover the frame
      clamp();
      render();
    }
    function clamp() {
      var fw = frame.clientWidth, fh = frame.clientHeight;
      var w = st.natW * st.base * st.scale;
      var h = st.natH * st.base * st.scale;
      var maxX = Math.max(0, (w - fw) / 2);
      var maxY = Math.max(0, (h - fh) / 2);
      st.x = Math.min(maxX, Math.max(-maxX, st.x));
      st.y = Math.min(maxY, Math.max(-maxY, st.y));
    }
    function render() {
      var w = st.natW * st.base * st.scale;
      var h = st.natH * st.base * st.scale;
      img.style.width = w + "px";
      img.style.height = h + "px";
      img.style.transform = "translate(-50%,-50%) translate(" + st.x + "px," + st.y + "px)";
    }
    function resetTransform() {
      st.scale = 1; st.x = 0; st.y = 0;
      if (zoomEl) zoomEl.value = 100;
      if (zoomVal) zoomVal.textContent = "100%";
      fitCover();
    }

    /* ---- shape picker (absent when the product is locked) ---- */
    document.querySelectorAll(".crp-shapes .cr-shape").forEach(function (b) {
      b.addEventListener("click", function () {
        var s = b.getAttribute("data-shape");
        if (!frame || frame.getAttribute("data-shape") === s) return;
        document.querySelectorAll(".crp-shapes .cr-shape").forEach(function (x) {
          x.classList.remove("on"); x.setAttribute("aria-pressed", "false");
        });
        b.classList.add("on"); b.setAttribute("aria-pressed", "true");
        frame.setAttribute("data-shape", s);
        if (note) note.textContent = shapeCopy[s];
        if (shapeField) shapeField.value = shapeName[s];
        frame.classList.remove("swept"); void frame.offsetWidth; frame.classList.add("swept");
        requestAnimationFrame(fitCover);
      });
    });

    /* ---- size / variant picker ---- */
    var sizeBtns = document.querySelectorAll(".crp-size");
    sizeBtns.forEach(function (b) {
      b.addEventListener("click", function () {
        sizeBtns.forEach(function (x) { x.classList.remove("on"); x.setAttribute("aria-pressed", "false"); });
        b.classList.add("on"); b.setAttribute("aria-pressed", "true");
        if (variantInput) variantInput.value = b.getAttribute("data-variant");
        if (priceEl) priceEl.textContent = b.getAttribute("data-price");
        applyAspectFrom(b.getAttribute("data-size") || b.textContent);
      });
    });
    /* ---- landscape / portrait (rectangle products) ---- */
    document.querySelectorAll(".crp-or").forEach(function (b) {
      b.addEventListener("click", function () {
        var o = b.getAttribute("data-orient");
        if (o === orient) return;
        orient = o;
        document.querySelectorAll(".crp-or").forEach(function (x) {
          x.classList.toggle("on", x === b);
          x.setAttribute("aria-pressed", x === b ? "true" : "false");
        });
        if (orientField) orientField.value = o === "portrait" ? "Portrait" : "Landscape";
        st.x = 0; st.y = 0;
        applyAspectFrom();
      });
    });

    // set the starting aspect from whichever size is pre-selected
    var preSize = document.querySelector(".crp-size.on");
    if (preSize) applyAspectFrom(preSize.getAttribute("data-size") || preSize.textContent);

    /* ---- quantity ---- */
    document.querySelectorAll("[data-crp-qty]").forEach(function (b) {
      b.addEventListener("click", function () {
        var n = Math.max(1, parseInt(qtyInput.value, 10) + parseInt(b.getAttribute("data-crp-qty"), 10));
        qtyInput.value = n;
        if (qtyVal) qtyVal.textContent = n;
      });
    });

    /* ---- upload + live preview ---- */
    var MAX = 20 * 1024 * 1024;
    function showErr(msg) { if (!errEl) return; errEl.textContent = msg || ""; errEl.hidden = !msg; }

    function handleFile(file) {
      if (!file) return;
      if (file.size > MAX) {
        showErr("That file is larger than 20 MB. Please upload a smaller image.");
        fileInput.value = "";
        return;
      }
      showErr("");
      if (dropMain) dropMain.innerHTML = "<b>" + file.name + "</b> — tap to change";
      drop.classList.add("has-file");

      if (file.type.indexOf("image/") === 0) {
        var reader = new FileReader();
        reader.onload = function (e) {
          img.onload = function () {
            st.natW = img.naturalWidth;
            st.natH = img.naturalHeight;
            st.isImage = true;
            artWrap.hidden = false;
            if (empty) empty.hidden = true;
            frame.classList.add("has-art");
            if (adjust) adjust.hidden = false;
            resetTransform();
          };
          img.src = e.target.result;
        };
        reader.readAsDataURL(file);
      } else {
        // PDF — no inline preview or positioning
        st.isImage = false;
        artWrap.hidden = true;
        if (adjust) adjust.hidden = true;
        if (empty) {
          empty.hidden = false;
          empty.querySelector("b").textContent = "PDF attached";
          empty.querySelector("span").textContent = file.name;
        }
      }
    }

    if (fileInput) fileInput.addEventListener("change", function () { handleFile(fileInput.files[0]); });

    /* ---- drag to reposition ---- */
    var dragging = false, lastX = 0, lastY = 0;
    function down(e) {
      if (!st.isImage) return;
      dragging = true;
      artWrap.classList.add("grabbing");
      var p = e.touches ? e.touches[0] : e;
      lastX = p.clientX; lastY = p.clientY;
      if (!e.touches) e.preventDefault();
    }
    function move(e) {
      if (!dragging) return;
      var p = e.touches ? e.touches[0] : e;
      st.x += p.clientX - lastX;
      st.y += p.clientY - lastY;
      lastX = p.clientX; lastY = p.clientY;
      clamp(); render();
      if (e.touches) e.preventDefault();
    }
    function up() { dragging = false; artWrap.classList.remove("grabbing"); }

    if (artWrap) {
      artWrap.addEventListener("mousedown", down);
      window.addEventListener("mousemove", move);
      window.addEventListener("mouseup", up);
      artWrap.addEventListener("touchstart", down, { passive: true });
      artWrap.addEventListener("touchmove", move, { passive: false });
      window.addEventListener("touchend", up);
    }

    /* ---- zoom ---- */
    if (zoomEl) zoomEl.addEventListener("input", function () {
      st.scale = parseInt(zoomEl.value, 10) / 100;
      if (zoomVal) zoomVal.textContent = zoomEl.value + "%";
      clamp(); render();
    });
    if (resetBtn) resetBtn.addEventListener("click", resetTransform);
    window.addEventListener("resize", function () { requestAnimationFrame(fitCover); });

    /* ---- render exactly what the customer positioned ---- */
    function composeBlob(cb) {
      if (!st.isImage) { cb(null); return; }
      try {
        var fw = frame.clientWidth, fh = frame.clientHeight;
        if (!fw || !fh) { cb(null); return; }
        var outW = 1600;
        var outH = Math.round(outW / aspect);
        var k = outW / fw;
        var c = document.createElement("canvas");
        c.width = outW; c.height = outH;
        var ctx = c.getContext("2d");
        ctx.fillStyle = "#ffffff";
        ctx.fillRect(0, 0, outW, outH);
        var dw = st.natW * st.base * st.scale * k;
        var dh = st.natH * st.base * st.scale * k;
        var dx = outW / 2 + st.x * k - dw / 2;
        var dy = outH / 2 + st.y * k - dh / 2;
        ctx.drawImage(img, dx, dy, dw, dh);
        c.toBlob(function (b) { cb(b); }, "image/jpeg", 0.92);
      } catch (err) { cb(null); }
    }

    function attachComposed(blob, done) {
      if (!blob || !composed) { done(); return; }
      try {
        var dt = new DataTransfer();
        dt.items.add(new File([blob], "positioned-preview.jpg", { type: "image/jpeg" }));
        composed.files = dt.files;
      } catch (err) { /* older browser: skip the extra file */ }
      done();
    }

    /* ---- submit (FormData so the files actually upload) ---- */
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      showErr("");
      if (fileInput && fileInput.files.length === 0) {
        showErr("Please upload your artwork so we can make your rug.");
        drop.classList.add("shake");
        setTimeout(function () { drop.classList.remove("shake"); }, 500);
        drop.scrollIntoView({ behavior: "smooth", block: "center" });
        return;
      }
      setLoading(submit, true);
      composeBlob(function (blob) {
        attachComposed(blob, function () {
          var fd = new FormData(form);
          fd.append("properties[Positioning]",
            st.isImage ? ("zoom " + Math.round(st.scale * 100) + "%") : "n/a (PDF)");
          fetch(R.routes.cart_add + ".js", { method: "POST", body: fd })
            .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
            .then(function (res) {
              setLoading(submit, false);
              if (!res.ok) {
                showErr(res.data && res.data.description ? res.data.description : "Could not add to cart. Please try again.");
                return;
              }
              refreshCart(); openCart();
              toast("Added — your design is attached to the order");
            })
            .catch(function () {
              setLoading(submit, false);
              showErr("Upload failed. Check your connection and try again.");
            });
        });
      });
    });

    /* ---- drag & drop onto the upload box ---- */
    if (drop) {
      ["dragenter", "dragover"].forEach(function (ev) {
        drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add("dragging"); });
      });
      ["dragleave", "drop"].forEach(function (ev) {
        drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove("dragging"); });
      });
      drop.addEventListener("drop", function (e) {
        var f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
        if (!f) return;
        try { var dt = new DataTransfer(); dt.items.add(f); fileInput.files = dt.files; } catch (err) {}
        handleFile(f);
      });
    }
  })();

  /* ---------- custom rug builder: shape picker ---------- */
  (function () {
    var frame = document.getElementById("crFrame");
    if (!frame) return;
    var note = document.getElementById("crShapeNote");
    var btns = document.querySelectorAll(".cr-shape");
    var copy = {
      round: "Perfectly round — a classic centrepiece.",
      square: "Clean square — great for bedsides and entryways.",
      rect: "Rectangle — the safe bet under beds and sofas."
    };
    btns.forEach(function (b) {
      b.addEventListener("click", function () {
        var shape = b.getAttribute("data-shape");
        if (frame.getAttribute("data-shape") === shape) return;
        btns.forEach(function (x) { x.classList.remove("on"); x.setAttribute("aria-pressed", "false"); });
        b.classList.add("on");
        b.setAttribute("aria-pressed", "true");
        frame.setAttribute("data-shape", shape);
        if (note && copy[shape]) note.textContent = copy[shape];
        // replay the sheen sweep
        frame.classList.remove("swept");
        void frame.offsetWidth;
        frame.classList.add("swept");
      });
    });
  })();

  /* ---------- scroll progress indicator ---------- */
  (function () {
    var bar = document.getElementById("scrollProgress");
    if (!bar) return;
    var ticking = false;
    function update() {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      var pct = h > 0 ? (window.scrollY / h) * 100 : 0;
      bar.style.transform = "scaleX(" + (pct / 100) + ")";
      ticking = false;
    }
    window.addEventListener("scroll", function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    update();
  })();

  /* ---------- animated number counters (stats section) ---------- */
  (function () {
    var stats = document.querySelectorAll(".stat b");
    if (!stats.length) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    var seen = new WeakSet();
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting || seen.has(en.target)) return;
        seen.add(en.target);
        var el = en.target;
        var raw = el.textContent.trim();
        // pull the number out, keep any prefix/suffix (e.g. "5,000+" or "4.9★")
        var m = raw.match(/([\d.,]+)/);
        if (!m) return;
        var numStr = m[1];
        var target = parseFloat(numStr.replace(/,/g, ""));
        if (isNaN(target)) return;
        var decimals = (numStr.split(".")[1] || "").length;
        var hasComma = numStr.indexOf(",") > -1;
        var start = performance.now();
        var dur = 1400;
        function fmt(n) {
          var s = decimals ? n.toFixed(decimals) : Math.round(n).toString();
          if (hasComma) s = Number(s).toLocaleString();
          return raw.replace(numStr, s);
        }
        function step(now) {
          var p = Math.min(1, (now - start) / dur);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = fmt(target * eased);
          if (p < 1) requestAnimationFrame(step);
          else el.textContent = raw;
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.4 });
    stats.forEach(function (s) { obs.observe(s); });
  })();

  /* Page transitions are handled declaratively in CSS via @view-transition
     (navigation: auto), which is safer than intercepting link clicks. */

  /* ---------- predictive search ---------- */
  (function () {
    var box = document.getElementById("searchBox");
    if (!box) return;
    var input = document.getElementById("searchInput");
    var out = document.getElementById("searchResults");
    var timer, lastQ = "";

    function openSearch() {
      box.classList.add("show");
      box.setAttribute("aria-hidden", "false");
      document.body.style.overflow = "hidden";
      setTimeout(function () { input.focus(); }, 60);
    }
    function closeSearch() {
      box.classList.remove("show");
      box.setAttribute("aria-hidden", "true");
      document.body.style.overflow = "";
    }
    document.addEventListener("click", function (e) {
      if (e.target.closest("[data-open-search]")) { e.preventDefault(); openSearch(); }
      if (e.target.closest("[data-close-search]")) { e.preventDefault(); closeSearch(); }
      if (e.target === box) closeSearch();
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && box.classList.contains("show")) closeSearch();
    });

    function render(items, q) {
      if (!items.length) {
        out.innerHTML = '<p class="search-empty">No matches for &ldquo;' + q.replace(/[<>&]/g, "") + '&rdquo;</p>';
        return;
      }
      out.innerHTML = items.map(function (p) {
        var img = p.featured_image && p.featured_image.url
          ? '<img src="' + p.featured_image.url + '" alt="" loading="lazy" width="56" height="56">'
          : '<span class="ph"></span>';
        return '<a class="search-item" href="' + p.url + '">' + img +
          '<span class="search-info"><b>' + p.title + '</b><span>' + (p.price ? money(p.price) : "") + "</span></span></a>";
      }).join("");
    }

    function search(q) {
      fetch("/search/suggest.json?q=" + encodeURIComponent(q) + "&resources[type]=product&resources[limit]=6")
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var items = (d.resources && d.resources.results && d.resources.results.products) || [];
          render(items, q);
        })
        .catch(function () { out.innerHTML = ""; });
    }

    if (input) input.addEventListener("input", function () {
      var q = input.value.trim();
      if (q === lastQ) return;
      lastQ = q;
      clearTimeout(timer);
      if (q.length < 2) { out.innerHTML = ""; return; }
      out.innerHTML = '<p class="search-empty">Searching…</p>';
      timer = setTimeout(function () { search(q); }, 220);
    });
  })();

  /* ---------- social proof purchase notifications ---------- */
  (function () {
    var el = document.getElementById("socialProof");
    var dataEl = document.getElementById("SocialProofData");
    if (!el || !dataEl) return;
    if (sessionStorage.getItem("rugzi_sp_off")) return;

    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!data.products || !data.products.length) return;

    var cfg = (R.socialProof || { first: 15, gap: 40 });
    var i = 0;
    var nameEl = el.querySelector(".sproof-name");
    var prodEl = el.querySelector(".sproof-prod");
    var timeEl = el.querySelector(".sproof-time");
    var imgEl = el.querySelector(".sproof-img");
    var linkEl = el.querySelector(".sproof-link");

    function show() {
      var p = data.products[Math.floor(Math.random() * data.products.length)];
      var n = data.names[i % data.names.length];
      i++;
      nameEl.textContent = (n || "Someone").trim();
      prodEl.textContent = "purchased " + p.title;
      timeEl.textContent = (2 + Math.floor(Math.random() * 40)) + " minutes ago";
      linkEl.href = p.url;
      if (p.image) { imgEl.src = p.image; imgEl.style.display = ""; } else { imgEl.style.display = "none"; }
      el.classList.add("show");
      el.setAttribute("aria-hidden", "false");
      setTimeout(function () { el.classList.remove("show"); el.setAttribute("aria-hidden", "true"); }, 6000);
    }

    var loop;
    setTimeout(function () {
      show();
      loop = setInterval(show, Math.max(10, cfg.gap) * 1000);
    }, Math.max(3, cfg.first) * 1000);

    el.querySelector(".sproof-close").addEventListener("click", function () {
      el.classList.remove("show");
      clearInterval(loop);
      try { sessionStorage.setItem("rugzi_sp_off", "1"); } catch (e) {}
    });
  })();

  /* ---------- rotating announcement bar ---------- */
  (function () {
    var bar = document.querySelector(".ann[data-rotate]");
    if (!bar) return;
    var msgs = bar.querySelectorAll(".ann-msg");
    if (msgs.length < 2) return;
    var i = 0;
    var every = (parseInt(bar.getAttribute("data-rotate"), 10) || 5) * 1000;
    setInterval(function () {
      msgs[i].classList.remove("on");
      i = (i + 1) % msgs.length;
      msgs[i].classList.add("on");
    }, every);
  })();

  /* ---------- keyboard: close drawer/lightbox with Escape ---------- */
  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    var d = document.getElementById("cartDrawer");
    if (d && d.classList.contains("show")) closeCart();
  });

  /* ---------- back to top ---------- */
  var toTop = document.getElementById("toTop");
  if (toTop) {
    window.addEventListener("scroll", function () { toTop.classList.toggle("show", window.scrollY > 600); });
    toTop.addEventListener("click", function () { window.scrollTo({ top: 0, behavior: "smooth" }); });
  }

  /* ---------- discount popup (exit-intent + delay) ---------- */
  (function () {
    var p = document.getElementById("promoPopup");
    if (!p) return;
    var KEY = "rugzi_promo_seen";
    var DONE = "rugzi_promo_subscribed";
    var delay = parseInt(p.getAttribute("data-delay"), 10) || 0;
    var shown = false;
    function open() { if (shown) return; shown = true; p.classList.add("show"); p.setAttribute("aria-hidden", "false"); sessionStorage.setItem(KEY, "1"); }
    function close() { p.classList.remove("show"); p.setAttribute("aria-hidden", "true"); }

    // Shopify reloads the page after signup — reopen so the code is visible.
    var justSubscribed = p.querySelector(".promo-reveal") !== null;
    var hasError = p.querySelector(".promo-err") !== null;
    if (justSubscribed || hasError) {
      open();
      if (justSubscribed) { try { localStorage.setItem(DONE, "1"); } catch (e) {} }
    } else {
      // don't nag people who already subscribed, or who saw it this session
      var already = false;
      try { already = localStorage.getItem(DONE) === "1"; } catch (e) {}
      if (already || sessionStorage.getItem(KEY)) return;
      if (delay > 0) setTimeout(open, delay * 1000);
      document.addEventListener("mouseout", function (e) { if (!shown && e.clientY <= 0 && !e.relatedTarget) open(); });
    }

    p.querySelector(".promo-close").addEventListener("click", close);
    var noBtn = p.querySelector(".promo-no");
    if (noBtn) noBtn.addEventListener("click", close);
    p.addEventListener("click", function (e) { if (e.target === p) close(); });
    var codeBtn = p.querySelector(".promo-code");
    if (codeBtn) codeBtn.addEventListener("click", function () {
      var c = codeBtn.getAttribute("data-code");
      if (navigator.clipboard) navigator.clipboard.writeText(c);
      toast("Code " + c + " copied");
    });
  })();

  /* ---------- recently viewed products ---------- */
  (function () {
    var KEY = "rugzi_recent";
    function get() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
    function save(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} }
    var pj = document.getElementById("ProductJSON");
    var current = null;
    if (pj) { try { current = JSON.parse(pj.textContent).handle; } catch (e) {} }
    if (current) {
      var a = get().filter(function (h) { return h !== current; });
      a.unshift(current);
      save(a.slice(0, 12));
    }
    var wrap = document.getElementById("recentlyViewed");
    if (!wrap) return;
    var track = wrap.querySelector(".hscroll");
    var list = get().filter(function (h) { return h !== current; }).slice(0, 8);
    if (!list.length) { wrap.style.display = "none"; return; }
    var done = 0, built = 0;
    list.forEach(function (handle) {
      fetch("/products/" + handle + ".js").then(function (r) { return r.ok ? r.json() : null; }).then(function (pr) {
        done++;
        if (pr) {
          built++;
          var img = pr.featured_image ? '<img src="' + pr.featured_image + '" alt="" loading="lazy">' : '<div class="ph">' + pr.title + "</div>";
          var price = money(pr.price);
          var cmp = pr.compare_at_price > pr.price ? "<s>" + money(pr.compare_at_price) + "</s>" : "";
          var el = document.createElement("div");
          el.className = "card";
          el.innerHTML = '<a class="card-img" href="' + pr.url + '">' + img + '</a>' +
            '<div class="card-body"><div class="stars">★★★★★</div>' +
            '<a href="' + pr.url + '"><div class="card-title">' + pr.title + '</div></a>' +
            '<div class="card-price">' + price + cmp + '</div></div>';
          track.appendChild(el);
        }
        if (done === list.length && !built) wrap.style.display = "none";
      }).catch(function () { done++; });
    });
  })();
})();
